// extracted by mini-css-extract-plugin
export default {"header":"Table_header__zCZ5A","link":"Table_link__DLb3R","active":"Table_active__85Q0V","inactive":"Table_inactive__FJ7mO"};